module.exports = __webpack_public_path__ + "static/media/bikerace.24797b27.jpg";